import styled from "styled-components";

export const CommonMasterWrapper = styled.div`
  .common-master-page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    background-color: #ffffff;
    border-radius: 1px;
    width: 100%;
    margin-top: -8px;
    margin-bottom: 8px;
    height: 64px;
    padding: 10px 16px;

    &_title {
      font-size: 28px;
      font-weight: var(--font-bold);
      color: var(--color-text-primary);
    }
  }

  .common-master-page-body {
    background-color: #ffffff;
    border-radius: 1px;
    width: 100%;

    &_btn {
      width: 100%;
      height: 48px;
      font-weight: 700;
      border-color: var(--color-primary) !important;
      color: var(--color-primary) !important;
      background: var(--bg-color) !important;
      &:hover {
        background-color: var(--color-hover-primary) !important;
        border-color: var(--color-hover-primary) !important;
        color: var(--color-primary) !important;
      }
    }

    &__search-btn {
      top: 4px;
      width: 100%;
      height: 48px;
      font-weight: 700;
      background-color: var(--color-primary);
      color: #ffffff;
      &:hover {
        background-color: var(--color-hover-primary) !important;
        border-color: var(--color-hover-primary) !important;
        color: #ffffff !important;
      }
    }
    &__search-btn-disable {
      top: 4px;
      width: 100%;
      height: 48px;
      background-color: #eaecf0;
      font-weight: 700;
      color: #98a2b3;
    }
    &__input-disable {
      border-color: #98a2b3 !important;
      color: #070708;
      font-weight: 400;
      &:hover {
        border-color: #98a2b3 !important;
      }
    }
    &__clear-btn {
      border-radius: 8px;
      top: 4px;
      width: 100%;
      height: 48px;
      font-weight: 700;
      border-color: var(--color-primary);
      color: var(--color-primary);
      &:hover {
        background-color: var(--color-hover-primary) !important;
        border-color: var(--color-hover-primary) !important;
        color: #ffffff !important;
      }
    }
    .common-master-page-table {
      padding: 16px;
      height: 100%;
      margin-top: -30px;
    }

    form {
      .ant-select-single,
      .ant-input-affix-wrapper {
        height: 48px;
      }
      .ant-input {
        height: 48px;
      }
      .ant-select-selector {
        height: 48px;
      }
      .ant-select-selector {
        .ant-select-selection-search {
          .ant-select-selection-search-input {
            height: 100%;
            font-size: var(--font-size-xl);
            font-weight: var(--font-medium);
          }
        }
      }
    }
    .ant-select-open .ant-select-selector {
      border-width: 2px !important;
      border-color: var(--color-primary) !important;
      box-shadow: 0px 0px 0px 2px #fd980033 !important;
      outline: none !important;
    }
    .ant-select-focused .ant-select-selector,
    .ant-select-open .ant-select-selector {
      border-width: 2px !important;
      border-color: var(--color-primary) !important;
      box-shadow: 0px 0px 0px 2px #fd980033 !important;
      outline: none !important;
    }
    .ant-input-outlined:focus-within {
      border-width: 2px !important;
      border-color: var(--color-primary) !important;
      box-shadow: 0px 0px 0px 2px #fd980033 !important;
      outline: none !important;
    }
  }
`;
